import axios from "axios";
import { LANGUAGE_KEY } from "../CountryContext";
import { API_URL } from "../utils/constants";

const getLocale = async (country) => {
  return axios.get(
    `/${country.code}${API_URL}/locale/all?locale=${localStorage.getItem(
      LANGUAGE_KEY
    )}`
  );
};

export default getLocale;
